import { render } from "./trustHistory.vue?vue&type=template&id=56e1a82e"
import script from "./trustHistory.vue?vue&type=script&lang=js"
export * from "./trustHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__